import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import AuthGuard from "./components/auth/AuthGuard";
import { message } from "antd";
import { useEffect } from "react";
import { setToastApi } from "./utils/toast";

function App() {
  const [messageApi, contextHolder] = message.useMessage();

  useEffect(() => {
    setToastApi({
      success: (content) => messageApi.success(content),
      error: (content) => messageApi.error(content),
      warning: (content) => messageApi.warning(content),
      info: (content) => messageApi.info(content),
    });
  }, [messageApi]);

  return (
    <I18nextProvider i18n={i18n}>
      {contextHolder}
      <BrowserRouter basename={__BASE_PATH__}>
        <AuthGuard>
          <AppRoutes />
        </AuthGuard>
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
